import { Button, CircularProgress, TextField } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import DeleteIcon from "@material-ui/icons/Delete";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import "./infoDetails.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getVocabularyContents,
  getVocabularyWordList,
  resetAddWordToListParams,
  resetDeleteWordParams,
  resetEditNoteParams,
  updateVocabularyEditWordNote,
  vocabularyAddWord,
  vocabularyAddWordToList,
  vocabularyDeleteWord,
} from "../../../../redux/actions/vocabularyCenterAction";
import { USER, VOCABULARY_ACTION, VOCABULARY_TYPE, VOCABULARY_WORDLIST } from "../../../../redux/constants";
import { LANGUAGE_ENGLISH, POS_DETAILS, TRANSLATION } from "../../VocabularyCenter/optionConstants";
import translate from "../../../../i18n/translate";

const AddWords = ({ handleClose, infoDetails, newWordTitle, setShowAddWordList }: any) => {
  const dispatch = useDispatch();
  const [addNewWord, setAddNewWord] = useState<boolean>(false);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [isEditClicked, setIsEditClicked] = useState<boolean>(false);
  const [isDeleteClicked, setIsDeleteClicked] = useState<boolean>(false);
  const [notes, setNotes] = useState<string>("");
  const reduxStore = useSelector((state: any) => state);
  const [searchedWord, setSearchedWord] = useState<any>({});
  const [usersLists, setUsersLists] = useState<any>([]);
  const [selectedUserList, setSelectedUserList] = useState<any>("");
  const [showAddToList, setShowAddToList] = useState<boolean>(false);
  const [newWordFormDetails, setNewWordFormDetails] = useState<any>({
    word: newWordTitle,
    def: "",
    translation: "",
    sentence: "",
    note: "",
    listId: "",
    posId: "",
    pos: "",
    slang: 0,
    type: USER,
  });

  useEffect(() => {
    if (
      reduxStore &&
      reduxStore.vocabularyContents &&
      reduxStore.vocabularyContents.isWordSearching !== null &&
      !reduxStore.vocabularyContents.isWordSearching &&
      infoDetails === undefined
    ) {
      const isErrorOccurred = reduxStore.vocabularyContents.searchedWordError;
      if (reduxStore.vocabularyContents.isSearchedWordDetailsAvailable && Object.keys(isErrorOccurred).length < 1) {
        const searchedWord = reduxStore.vocabularyContents.searchedWordDetails.word;
        setSearchedWord(searchedWord[0]);
      } else {
        setSearchedWord({
          showMessage: true,
          message: translate("vocab_center_new_word_message"),
        });
      }
    }
    if (
      reduxStore &&
      reduxStore.vocabularyContents &&
      reduxStore.vocabularyContents.editedNoteDetails &&
      Object.keys(reduxStore.vocabularyContents.editedNoteDetails).length > 0
    ) {
      const editNoteDetails = reduxStore.vocabularyContents.editedNoteDetails;
      if (searchedWord.defId === editNoteDetails.defId) {
        setSearchedWord({
          ...searchedWord,
          note: editNoteDetails.note,
        });
      } else if (searchedWord.defid === editNoteDetails.defId) {
        setSearchedWord({
          ...searchedWord,
          note: editNoteDetails.note,
        });
      }
    }
    if (reduxStore && reduxStore.vocabularyContents && reduxStore.vocabularyContents.headerLevelContents) {
      const usersListDetails = reduxStore.vocabularyContents.headerLevelContents["User"];
      const newUsersLists: any = [];
      if (usersListDetails && usersListDetails.userWordlists && usersListDetails.userWordlists.length > 0) {
        usersListDetails.userWordlists.forEach((userList: any) => {
          newUsersLists.push({
            listId: userList.listId,
            wordlist: userList.wordlist,
          });
        });
      }
      setUsersLists(newUsersLists);
    }
    if (
      reduxStore &&
      reduxStore.vocabularyContents &&
      reduxStore.vocabularyContents.isWordNoteUpdated &&
      Object.keys(reduxStore.vocabularyContents.editedNoteDetails).length > 0
    ) {
      handleEditCloseView();
      getVocabularyContentsDetails();
      handleClose();
    }
    if (
      reduxStore &&
      reduxStore.vocabularyContents &&
      !reduxStore.vocabularyContents.isWordDeleting &&
      reduxStore.vocabularyContents.isWordDeleted
    ) {
      dispatch(resetDeleteWordParams());
      getVocabularyContentsDetails();
      handleClose();
    }
  }, [reduxStore]);

  useEffect(() => {
    if (infoDetails) {
      setSearchedWord({
        audioPath: infoDetails.audioPath,
        word: infoDetails.word,
        pos: infoDetails.pos,
        definition: infoDetails.definition,
        translation: infoDetails.translation === "" ? undefined : infoDetails["Translation"],
        sentence: infoDetails.sentence,
        note: infoDetails.notes,
        defId: infoDetails.defId,
        posId: infoDetails.posId,
        wordId: infoDetails.wordId,
        wordlist: infoDetails.wordlist,
        isDeletable: infoDetails.isDeletable,
        listId: infoDetails.listId,
      });
    }
  }, [infoDetails]);

  const changeFormat = (url: any) => {
    return url.replace(".wav", ".mp3");
  };

  const handleNoteSaveEvent = () => {
    const SLANG = 0;
    dispatch(
      updateVocabularyEditWordNote(
        reduxStore.peopleInformation.data.getpeopleInformation.token,
        searchedWord.defId ?? searchedWord.defid,
        searchedWord.definition,
        searchedWord.sentence,
        notes,
        SLANG,
        parseInt(searchedWord.posId, 10)
      )
    );
  };

  const handleEditCloseView = () => {
    setNotes("");
    setIsEditClicked(false);
    dispatch(resetEditNoteParams());
  };

  const handleAddWordToList = () => {
    dispatch(resetAddWordToListParams());
    setTimeout(() => {
      dispatch(
        vocabularyAddWordToList(
          reduxStore.peopleInformation.data.getpeopleInformation.token,
          selectedUserList,
          searchedWord.wordId,
          VOCABULARY_TYPE,
          VOCABULARY_ACTION,
          VOCABULARY_WORDLIST
        )
      );
    }, 500);
    setTimeout(() => {
      getVocabularyContentsDetails();
    }, 700);
  };

  const getPosValue = (value: any) => {
    let returnValue = "";
    POS_DETAILS.forEach((posDetails: any) => {
      if (posDetails && posDetails.posId === value) {
        returnValue = posDetails.pos;
      }
    });
    return returnValue;
  };

  const getParameterByName = (key: any) => {
    const match = RegExp("[?&]" + key + "=([^&]*)").exec(window.location.search);
    const result = match && decodeURIComponent(match[1].replace(/\+/g, " "));
    return result;
  };

  const getVocabularyContentsDetails = () => {
    const peopleInfoStateValidation = reduxStore.peopleInformation ? reduxStore.peopleInformation.data : "";
    const idParam = getParameterByName("id") ?? "";
    dispatch(
      getVocabularyContents(
        reduxStore.common.lgId,
        peopleInfoStateValidation.getpeopleInformation.token,
        parseInt(peopleInfoStateValidation.getpeopleInformation.accountId, 10)
      )
    );
    dispatch(
      getVocabularyWordList(
        reduxStore.common.lgId,
        peopleInfoStateValidation.getpeopleInformation.token,
        idParam,
        TRANSLATION,
        LANGUAGE_ENGLISH
      )
    );
  };

  const handleAddNewWordAndSave = () => {
    const POS_NAME = getPosValue(newWordFormDetails.posId);
    dispatch(
      vocabularyAddWord(
        reduxStore.peopleInformation.data.getpeopleInformation.token,
        newWordFormDetails.def,
        newWordFormDetails.listId,
        newWordFormDetails.posId,
        POS_NAME,
        newWordFormDetails.sentence,
        newWordFormDetails.slang,
        newWordFormDetails.word,
        newWordFormDetails.type,
        newWordFormDetails.translation,
        newWordFormDetails.note
      )
    );
    setAddNewWord(false);
    setTimeout(() => {
      getVocabularyContentsDetails();
      handleClose();
    }, 800);
  };

  return (
    <div className="add-words-container">
      {reduxStore.vocabularyContents.isWordSearching ||
      reduxStore.vocabularyContents.isWordNoteUpdating ||
      reduxStore.vocabularyContents.isWordAddingToList ||
      reduxStore.vocabularyContents.isWordDeleting ||
      reduxStore.vocabularyContents.isWordCreating ? (
        <div className="pop-up-loading">
          <CircularProgress size={25} color="primary" />
        </div>
      ) : (
        <>
          {searchedWord && Object.keys(searchedWord).length === 0 && addNewWord && (
            <div className="add-new-word-container">
              <div className="title-container">
                <p className="new-word-label">{translate("vocab_center_new_word_text")}</p>
                <CloseIcon className="close-icon" onClick={() => handleClose()} />
              </div>
              <div className="new-word-details-box">
                <div className="select-pos-list-details">
                  <FormControl className="pos-list-drop-down">
                    <InputLabel id="demo-simple-select-label" className="pos-list-label">
                      {translate("vocab_center_pos_label")}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={newWordFormDetails.posId}
                      onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, posId: e.target.value })}
                      className="pos-list-select-action"
                    >
                      {POS_DETAILS.map((list: any) => (
                        <MenuItem value={list.posId} className="pos-list-label" key={list.posId}>
                          {list.pos}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {usersLists.length === 0 ? (
                    <p className="create-new-wordlist-title" onClick={() => {setShowAddWordList(true)}}>
                      + {translate("vocab_center_add_wordlist")}
                    </p>
                  ) : (
                    <FormControl className="user-list-drop-down">
                      <InputLabel id="demo-simple-select-label" className="user-list-label">
                        {translate("vocab_center_select_wordlist_text")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={newWordFormDetails.listId}
                        onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, listId: e.target.value })}
                        className="user-list-select-action"
                      >
                        {usersLists.map((list: any) => (
                          <MenuItem value={list.listId} className="users-list-label" key={list.listId}>
                            {list.wordlist}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </div>
                <div className="input-of-word">
                  <TextField
                    required
                    id="outlined-required"
                    label={translate("vocab_center_word_label")}
                    className="word-input"
                    value={newWordFormDetails.word}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <TextField
                    required
                    id="outlined-required"
                    label={translate("vocab_center_definition_label")}
                    className="definition-input"
                    value={newWordFormDetails.def}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, def: e.target.value })}
                  />
                  <TextField
                    id="outlined-required"
                    label={translate("vocab_center_translation_label")}
                    className="translation-input"
                    value={newWordFormDetails.translation}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, translation: e.target.value })}
                  />
                  <TextField
                    id="outlined-required"
                    label={translate("vocab_center_sentence_label")}
                    className="sentence-input"
                    value={newWordFormDetails.sentence}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, sentence: e.target.value })}
                  />
                  <TextField
                    id="outlined-required"
                    label={translate("vocab_center_note_label")}
                    className="note-input"
                    value={newWordFormDetails.note}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, note: e.target.value })}
                  />
                </div>
                <div className="action-button-container">
                  <Button
                    variant="contained"
                    className="save-button-action"
                    disabled={
                      newWordFormDetails.word === "" ||
                      newWordFormDetails.def === "" ||
                      newWordFormDetails.posId === "" ||
                      newWordFormDetails.listId === ""
                    }
                    onClick={handleAddNewWordAndSave}
                  >
                    {translate("vocab_center_save_text")}
                  </Button>
                </div>
              </div>
            </div>
          )}
          {searchedWord && searchedWord.showMessage && Object.keys(searchedWord).length > 0 && (
            <div className="no-word-searched-container">
              <div className="title-container">
                <p className="new-word-label">{translate("vocab_center_new_word_text")}</p>
                <CloseIcon className="close-icon" onClick={() => handleClose()} />
              </div>
              <p className="no-work-searched-container-message">{searchedWord.message}</p>
              <div className="no-word-searched-actions">
                <Button
                  variant="contained"
                  className="no-work-searched-action-btn-1"
                  onClick={() => {
                    setSearchedWord({});
                    setAddNewWord(true);
                  }}
                >
                  {translate("vocab_center_okay_text")}
                </Button>
                <Button variant="contained" className="no-work-searched-action-btn-2" onClick={() => handleClose()}>
                  {translate("vocab_center_cancel_text")}
                </Button>
              </div>
            </div>
          )}
          {searchedWord.showMessage === undefined &&
            !addNewWord &&
            (isDeleteClicked ? (
              <div className="delete-warning-container">
                <div className="title-container">
                  <p className="new-word-label">{translate("vocab_center_delete_word_text")}</p>
                  <CloseIcon
                    className="close-icon"
                    onClick={() => {
                      setIsDeleteClicked(false);
                    }}
                  />
                </div>
                <p className="delete-warning-message">{translate("vocab_center_delete_word_warning_message")}</p>
                <div className="delete-warning-actions">
                  <Button
                    variant="contained"
                    className="delete-button"
                    onClick={() => {
                      dispatch(
                        vocabularyDeleteWord(
                          reduxStore.peopleInformation.data.getpeopleInformation.token,
                          searchedWord.listId,
                          searchedWord.wordId,
                          USER
                        )
                      );
                      setIsDeleteClicked(false);
                    }}
                  >
                    {translate("vocab_center_yes_text")}
                  </Button>
                  <Button
                    variant="contained"
                    className="delete-button"
                    onClick={() => {
                      setIsDeleteClicked(false);
                    }}
                  >
                    {translate("vocab_center_close_text")}
                  </Button>
                </div>
              </div>
            ) : isEditClicked ? (
              <div className="note-container">
                <div className="close-icon-container">
                  <CloseIcon className="close-icon" onClick={handleEditCloseView} />
                </div>
                {reduxStore.vocabularyContents.isWordNoteUpdated ? (
                  <div className="notes-updated-message-box">
                    <p className="note-updated-message-para">{translate("vocab_center_note_updated_message")}</p>
                  </div>
                ) : (
                  <>
                    <p className="note-label">{translate("vocab_center_note_label")}:</p>
                    <textarea
                      className="note-comments-textarea"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                    />
                    <div className="note-container-actions">
                      <Button
                        variant="contained"
                        className="save-button"
                        onClick={() => handleNoteSaveEvent()}
                        disabled={notes.length === 0}
                      >
                        {translate("vocab_center_save_text")}
                      </Button>
                      <Button variant="contained" className="close-button" onClick={handleEditCloseView}>
                        {translate("vocab_center_close_text")}
                      </Button>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <>
                <div className="searched-content-container">
                  <div className="searched-content-header-wrapper">
                    <div className="searched-content-header">
                      <div className="searched-word-with-audio">
                        {searchedWord.audioPath && searchedWord.audioPath !== "" && (
                          <VolumeUpIcon
                            className="text-audio-button"
                            onClick={() => {
                              const audioTag = document.createElement("audio");
                              audioTag.src = `${process.env.REACT_APP_PROGRESS_URL}/content/${
                                searchedWord.audioPath ? changeFormat(searchedWord.audioPath) : ""
                              }`;
                              if (!isPlaying) {
                                audioTag.play();
                              }
                              audioTag.addEventListener("play", () => {
                                setIsPlaying(true);
                              });
                              audioTag.addEventListener("ended", () => {
                                setIsPlaying(false);
                              });
                            }}
                          />
                        )}
                        <p className="word-label">{searchedWord.word}</p>
                      </div>
                      <small className="word-type-label">{searchedWord.pos}</small>
                    </div>
                    <div className="close-icon-container">
                      <CloseIcon className="close-icon-button" onClick={() => handleClose()} />
                    </div>
                  </div>
                  <div className="searched-word-contents">
                    <label className="container-label">{translate("vocab_center_definition_label")}:</label>
                    <p className="definition-value">
                      {searchedWord.definition ?? translate("vocab_center_no_definition_text")}
                    </p>
                    <label className="container-label">{translate("vocab_center_translation_label")}:</label>
                    <p className="translation-value">
                      {searchedWord.translation ?? translate("vocab_center_no_translation_text")}
                    </p>
                    <label className="container-label">{translate("vocab_center_sentence_label")}:</label>
                    <p className="sentence-value">
                      {searchedWord.sentence
                        ? searchedWord.sentence.replace(/<\/?[^>]+(>|$)/g, "")
                        : undefined ?? translate("vocab_center_no_sentence_text")}
                    </p>
                    <label className="container-label">{translate("vocab_center_note_label")}:</label>
                    <p className="notes-value">
                      {searchedWord.note === ""
                        ? translate("vocab_center_no_note_text")
                        : searchedWord.note ?? translate("vocab_center_no_note_text")}
                    </p>
                  </div>
                  {showAddToList && (
                    <div className="users-lists-container">
                      {usersLists.length === 0 ? (
                        <p className="create-new-wordlist-title" onClick={() => setShowAddWordList(true)}>
                          There is no wordlist available, + {translate("vocab_center_add_wordlist")}
                        </p>
                      ) : (
                        <FormControl className="user-list-drop-down">
                          <InputLabel id="demo-simple-select-label" className="user-list-label">
                            {translate("vocab_center_select_wordlist_text")}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedUserList}
                            onChange={(e) => setSelectedUserList(e.target.value)}
                            className="user-list-select-action"
                          >
                            {usersLists.map((list: any) => (
                              <MenuItem value={list.listId} className="users-list-label" key={list.listId}>
                                {list.wordlist}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {reduxStore.vocabularyContents.isWordAddedToList && (
                        <p className="word-added-to-list-success-msg">{translate("vocab_center_word_save_message")}</p>
                      )}
                      {reduxStore.vocabularyContents.errorOnAddingWordToList &&
                        reduxStore.vocabularyContents.errorOnAddingWordToList.code === 406 && (
                          <p className="word-added-to-list-failure-msg">
                            {translate("vocab_center_word_exists_error_message")}
                          </p>
                        )}
                      <div className="user-list-saving-actions">
                        <Button variant="contained" onClick={handleAddWordToList} disabled={usersLists.length === 0}>
                          {translate("vocab_center_submit_text")}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() => {
                            dispatch(resetAddWordToListParams());
                            setShowAddToList(false);
                          }}
                        >
                          {translate("vocab_center_close_text")}
                        </Button>
                      </div>
                    </div>
                  )}
                  {!showAddToList && (
                    <div className="searched-word-container-action">
                      {searchedWord.isDeletable && (
                        <Button variant="contained" className="delete-button" onClick={() => setIsDeleteClicked(true)}>
                          <DeleteIcon className="delete-button-icon" />
                          <span className="add-button-label">{translate("vocab_center_delete_text")}</span>
                        </Button>
                      )}
                      <Button variant="contained" className="edit-button" onClick={() => setIsEditClicked(true)}>
                        <EditIcon className="edit-button-icon" />
                        <span className="edit-button-label">{translate("vocab_center_edit_text")}</span>
                      </Button>
                      <Button variant="contained" className="add-button" onClick={() => setShowAddToList(true)}>
                        <AddCircleIcon className="add-button-icon" />
                        <span className="add-button-label">{translate("vocab_center_add_text")}</span>
                      </Button>
                    </div>
                  )}
                </div>
              </>
            ))}
        </>
      )}
    </div>
  );
};

export default AddWords;
